import { render, staticRenderFns } from "./header-pricing.vue?vue&type=template&id=b4fc8e14&scoped=true"
import script from "./header-pricing.vue?vue&type=script&lang=js"
export * from "./header-pricing.vue?vue&type=script&lang=js"
import style0 from "./header-pricing.vue?vue&type=style&index=0&id=b4fc8e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fc8e14",
  null
  
)

export default component.exports